import {
  WheelConfigurationApi,
  WheelDto,
} from '@coretava/api/events-service';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import {
  action, computed, makeAutoObservable, observable, runInAction, when,
} from 'mobx';
import { CampaignUserStore } from '..';

class WheelStore {
  @observable initialized = false;

  @observable wheel?: WheelDto = undefined;

  constructor() {
    makeAutoObservable(this);

    void this.initialize();
  }

  @computed
  get wheelApi(): WheelConfigurationApi {
    return new WheelConfigurationApi({
      isJsonMime(): boolean {
        return true;
      },
      basePath: process.env.BASE_API_URL,
    });
  }

  @action
  initialize(): void {
    void this.fetchWheel();
  }

  @action
  async fetchWheel() {
    await when(() => !!CampaignUserStore.spinTheWheelCampaignUser || !!CampaignUserStore.spinTheWheelCampaign);

    if (CampaignUserStore.spinTheWheelCampaignUser?.campaign.booster?.id) {
      const response = await this.wheelApi.wheelsControllerGet(AppStore.app.id, CampaignUserStore.spinTheWheelCampaignUser.campaign.booster.id);
      runInAction(() => {
        this.wheel = response.data.wheel;
      });
    } else if (CampaignUserStore.spinTheWheelCampaign?.booster?.id) {
      const response = await this.wheelApi.wheelsControllerGet(AppStore.app.id, CampaignUserStore.spinTheWheelCampaign.booster.id);
      runInAction(() => {
        this.wheel = response.data.wheel;
      });
    }

    runInAction(() => {
      this.initialized = true;
    });
  }
}

export default new WheelStore();
